import React, { useEffect, useRef, useState } from "react";
// import Logo from "../assets/images/logo.jpeg";
import Logo from "../assets/images/logoIco.png";
import { Link } from "react-router-dom";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [navHeight, setNavHeight] = useState(0);
  const navRef = useRef(null);

  useEffect(() => {
    if (navRef.current) setNavHeight(navRef.current.offsetHeight);
    const handleScroll = () => setScrolled(window.scrollY > 200);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
    <nav ref={navRef} className={`navbar navbar-expand-lg navbar-light a1 mx-0 navFont pr-0${scrolled ? " navbar-scrolled" : ""}`}>
      <section className="container ">
        <div className=" text-center ">
          <Link
            className="navbar-brand p-0"
            style={{ marginTop: "-6px" }}
            to="/"
          >
            <img className="img-fluid" id="logo" src={Logo} alt="Logo" />
          </Link>
        </div>
        <div className="toggle-icon-custom">
          <button
            className="navbar-toggler btn-btn-toggle"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
        </div>
        <div
          className="collapse navbar-collapse  collapse-nav pr-0-lg"
          id="navbarNavAltMarkup"
        >
          <div className="flex-1">
            <div className="navbar-nav">
              <Link className="nav-item nav-link" to="/">
                Home{" "}
              </Link>
              <a className="nav-item nav-link" href="#services">
                Services
              </a>
              <a className="nav-item nav-link" href="#about">
                About
              </a>
              <Link className="nav-item nav-link" to="/booking">
                Book Now
              </Link>
            </div>
          </div>
          <a href="/#contact" className="sigupBtn">
            Contact Us
          </a>
        </div>
      </section>
    </nav>
    {scrolled && <div style={{ height: "80.6px" }} />}
    </>
  );
};
